import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function TagTicker({ tags = [] }) {
    const navigate = useNavigate();
    if (!tags.length) return null;
    const doubled = [...tags, ...tags];

    return (
        <div style={{
            borderTop: '1px solid #18181B',
            borderBottom: '1px solid #18181B',
            overflow: 'hidden',
            maskImage: 'linear-gradient(90deg, transparent, #000 5%, #000 95%, transparent)',
            WebkitMaskImage: 'linear-gradient(90deg, transparent, #000 5%, #000 95%, transparent)',
            background: '#0A0A0B',
        }}>
            <div style={{
                display: 'flex', gap: 8, padding: '9px 0',
                whiteSpace: 'nowrap', width: 'max-content',
                animation: 'hb-marquee 60s linear infinite',
            }}>
                {doubled.map((t, i) => (
                    <button
                        key={`${t.slug ?? t.name}-${i}`}
                        onClick={() => navigate(`/categories/${t.slug ?? t.name}`)}
                        style={{
                            padding: '4px 12px',
                            border: '1px solid #27272A',
                            background: '#101012',
                            color: '#D4D4D8',
                            borderRadius: 999,
                            fontSize: 11.5, fontWeight: 500,
                            flexShrink: 0, cursor: 'pointer',
                            fontFamily: "'Manrope', sans-serif",
                        }}
                    >
                        {t.name ?? t}
                    </button>
                ))}
            </div>
        </div>
    );
}
